import clsx from 'clsx';
import {
    useBlockProps,
    useInnerBlocksProps,
} from '@wordpress/block-editor';

/**
 * v2 save: Embla single-div (inner blocks merged onto block wrapper).
 */
export const deprecatedV2 = {
    attributes: {
        minHeight: {
            type: 'string',
            default: '',
        },
    },

    save( { attributes } ) {
        const { minHeight } = attributes;

        const blockProps = useBlockProps.save( {
            className: clsx( 'gwx-carousel__slide' ),
            style: {
                minHeight: minHeight || undefined,
            },
        } );

        const innerBlockProps = useInnerBlocksProps.save( blockProps );

        return <div { ...innerBlockProps } />;
    },
};

/**
 * v1 save: Splide-based with <li class="splide__slide">
 */
export const deprecatedV1 = {
    attributes: {
        minHeight: {
            type: 'string',
            default: '',
        },
    },

    save( { attributes } ) {
        const { minHeight } = attributes;

        const blockProps = useBlockProps.save( {
            className: clsx( 'splide__slide' ),
            style: {
                minHeight: minHeight || undefined,
            },
        } );

        const innerBlockProps = useInnerBlocksProps.save( blockProps );

        return <li { ...innerBlockProps } />;
    },
};
